import { useAuth0 } from '@auth0/auth0-vue'
import { TrafficType } from '@thyme/libs/src/flags/types'
import { onBeforeUnmount, watch } from 'vue'
import { useConfigStore } from '@/legacy/store/modules/config'
import { useFlagStore } from './flags'

const ROLES_CLAIM = 'https://thymecare.com/roles'

/**
 * Composable that reactively initializes feature flags when the Auth0
 * user's email becomes available, and tears down the Split client on
 * unmount.  Call once from App.vue setup.
 */
export function useFeatureFlags() {
  const auth = useAuth0()
  const flagStore = useFlagStore()
  const { configVals } = useConfigStore()

  watch(
    () => auth.user.value?.email,
    async (email) => {
      const user = auth.user.value
      if (!email || !user) return
      if (!configVals) {
        console.warn(
          'Config values not available yet; cannot initialize feature flags'
        )
        return
      }

      console.info(`Fetching feature flags for ${email}`)
      await flagStore.init(configVals.flags, {
        targetingKey: email,
        trafficType: TrafficType.THYMEBOX_USER,
        attributes: {
          email, // Duplicate this to make it more clear in the UI
          firstName: user.given_name ?? '',
          lastName: user.family_name ?? '',
          name: user.name ?? '',
          roles: user[ROLES_CLAIM] ?? [],
        },
      })
    },
    { immediate: true }
  )

  onBeforeUnmount(async () => {
    await flagStore.destroy()
  })
}
